import { useState } from 'react';
import type { Bulle } from '../partage/api/types';
import { champsDeLaDate, champsDuDelai, DELAIS_RAPIDES } from './delaisRapides';
import { ChampTape } from './Saisies';
import { useEchap } from '../partage/useEchap';
import { ANNULER, EXEMPLE_DE_DELAI, UNE_DATE_OU_UN_DELAI } from '../partage/vocabulaire';
import './FeuilleDesDelais.css';

/**
 * La petite feuille des délais, en bas de l'écran du téléphone (ticket 08 du chantier
 * telephone) : au retour de la banque, on
 * pose en un toucher ce qu'on vient d'entendre. 3 jours, 10 jours, 3 semaines posent le délai
 * du monde ; « Une date précise » ouvre le champ de date de « Quand » (l'échéance).
 *
 * Le choix passe par `onChanger`, le même chemin que « Quand » (`gestesDeFeuille`) ; ce qui a
 * bougé ailleurs se voit sur la carte et dans les dates, sans bandeau.
 *
 * Échap et le voile la ferment sans rien poser ; Échap ne ferme pas la fiche par-dessus.
 */
export function FeuilleDesDelais({
  bulle,
  onChanger,
  onFermer,
  titre = UNE_DATE_OU_UN_DELAI,
}: {
  bulle: Bulle;
  onChanger: (champs: Partial<Bulle>) => void;
  onFermer: () => void;
  /**
   * Ce qu'elle demande. « J'attends un retour », dans la fiche du téléphone (chantier
   * `telephone-projets-fiche`, ticket 03), la reprend telle quelle : le choix part avec l'attente.
   */
  titre?: string;
}) {
  const [date, setDate] = useState(false);

  // Échap ne ferme qu'elle, avant même le champ de date et la fiche dessous.
  useEchap(true, onFermer, 'avant-tout');

  function poser(champs: Partial<Bulle>) {
    onFermer();
    onChanger(champs);
  }

  return (
    <>
      <div className="delais-voile" onClick={onFermer} aria-hidden="true" />
      <div className="delais" role="dialog" aria-label={titre}>
        <h3>{titre}</h3>
        <p className="delais-exemple">{EXEMPLE_DE_DELAI}</p>

        <div className="delais-puces">
          {DELAIS_RAPIDES.map((d) => (
            <button
              key={d.mot}
              type="button"
              className="delais-puce"
              aria-pressed={d.sorte === 'date' ? date : bulle.delaiJours === d.jours}
              onClick={() => (d.sorte === 'jours' ? poser(champsDuDelai(d.jours)) : setDate(true))}
            >
              {d.mot}
            </button>
          ))}
        </div>

        {date && (
          <ChampTape
            sorte="jour"
            className="champs-date delais-date"
            data-tuto="champ-date"
            autoFocus
            aria-label="la date"
            valeur={bulle.dateEcheance ?? ''}
            onEcrire={(jour) => {
              const champs = champsDeLaDate(jour);
              if (champs) poser(champs);
            }}
          />
        )}

        <button type="button" className="bouton bouton-discret delais-annuler" onClick={onFermer}>
          {ANNULER}
        </button>
      </div>
    </>
  );
}
